import { render, staticRenderFns } from "./OPGeneralDetail.vue?vue&type=template&id=0bc534e0&"
import script from "./OPGeneralDetail.vue?vue&type=script&lang=js&"
export * from "./OPGeneralDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports